import React from 'react'; 
 
import * as S from '../styles';

import Select from '../../../../components/Inputs/Select';
import Button from '../../../../components/Button'; 

function PesquisaMunicipio({ formData, handleChangeInput, handleSearch }) {
  return ( 
    <S.SectionContainer> 
      <S.FirstColumn>
          <S.Row>
            <Select
              field={formData.healthPlan}
              onChange={handleChangeInput}
            /> 
            <Select
              field={formData.state}
              onChange={handleChangeInput}
            />
            <Select
              field={formData.city}
              onChange={handleChangeInput}
            />
          </S.Row>
      </S.FirstColumn>

      <S.SecondColumn>
        <Button type="primary" onClick={handleSearch}>
          Pesquisar
        </Button> 
      </S.SecondColumn>
    </S.SectionContainer> 
  );
}

export default PesquisaMunicipio;